export const PDF_REQUEST_STATUS = [
    'Order Placed',
    'Generated',
    "Payment Pending",
    'Printed',
    'Mailed',
    'Completed'
];

export const availablePartners = ["CP-Letters", "CP-Postcards"];

export const availablePlans = ['Starter', 'Grow', 'Pro'];

export const FONT_BASE_URL = 'https://fonts-reachpersona.b-cdn.net/fonts';
